import {AfterViewInit, Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validators
} from "@angular/forms";
import {CoreService} from "../../../../../services/core/core.service";
import {first, pairwise, startWith} from "rxjs/operators";
import {SharedService} from "../../../../shared/shared.service";
import {Subscription, forkJoin} from "rxjs";
import {StaffService} from "../../../../../services/staff/staff.service";
import {UserService} from "../../../../../services/core/user.service";
import { SubofficeService } from 'src/app/modules/setting/company-settings/suboffice/suboffice.service';

@Component({
    selector: 'app-assignment-form',
    templateUrl: './assignment-form.component.html',
    styleUrls: ['./assignment-form.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AssignmentFormComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => AssignmentFormComponent),
            multi: true
        }
    ],
    standalone: false
})
export class AssignmentFormComponent implements OnInit, AfterViewInit {

  @Input() model: any = {};
  @Input() form: any = {};
  @Input() bidDetailForm: any = {};     //    console.log('this.bidForm?.value?.step01?.bidDetail', this.bidForm?.value?.step01?.bidDetail);
  @Input() isEdit: boolean = false;
  @Output() callback = new EventEmitter<any>(true);

  public staffs: any[] = [];
  public sales_reps: any[] = [];
  public project_managers: any[] = [];
  public estimators: any[] = [];
  //@ts-ignore
  public assignmentDetailFormSubscription: Subscription;
  public tenantIdSubscription: Subscription = new Subscription();
  public customerSubscription: Subscription = new Subscription();
  public assignmentDetailForm: UntypedFormGroup = new UntypedFormGroup({
    project_manager_id: new UntypedFormControl(null,[Validators.required]),
    assigned_to_id: new UntypedFormControl(null,[]),
    estimator_id: new UntypedFormControl(null,[]),
    sales_rep_id: new UntypedFormControl(null,[Validators.required]),
    secondary_sales_rep_id: new UntypedFormControl(null,[]),
  });
  CONST_ALL_STAFF = 'ALL';
  CONST_PROJECT_MANAGER = 'PROJECT-MANAGER';
  CONST_ESTIMATOR = 'ESTIMATOR';
  CONST_SALES_REP = 'SALES-REP';

  constructor(
    public sharedService: SharedService,
    public coreService: CoreService,
    public staffService: StaffService,
    private currentUser: UserService,
    public subofficeService: SubofficeService

  ) { }

  ngOnInit(): void {
    this.initSubscriptions();
    this.initCustomerSubscription();
    this.initSatffMembers();

  
  }

  ngAfterViewInit(): void {

  }

  setDataOnEdit = () => {
    if(this.isEdit) {
      this.assignmentDetailForm?.get('project_manager_id')?.setValue(this.staffService.getStaffById(this.staffs, this.model?.project_manager?.id));
      this.assignmentDetailForm?.get('assigned_to_id')?.setValue(this.staffService.getStaffById(this.staffs, this.model?.assignee?.id));
      this.assignmentDetailForm?.get('estimator_id')?.setValue(this.staffService.getStaffById(this.staffs, this.model?.estimator?.id));
      this.assignmentDetailForm?.get('sales_rep_id')?.setValue(this.staffService.getStaffById(this.staffs, this.model?.sales_rep?.id));
      this.assignmentDetailForm?.get('secondary_sales_rep_id')?.setValue(this.staffService.getStaffById(this.staffs, this.model?.secondarySalesRep?.id));
      // this.assignmentDetailForm?.setValue({
      //   assigned_to_id: {id:this.model?.assignee?.id, name: this.model?.assignee?.full_name},
      //   estimator_id: {id:this.model?.estimator?.id, name: this.model?.estimator?.full_name},
      //   sales_rep_id: {id:this.model?.sales_rep?.id, name: this.model?.sales_rep?.full_name}
      // });
    }else{
      const currentUserID = this.currentUser?.getID();
      if (currentUserID){
        this.assignmentDetailForm?.get('assigned_to_id')?.setValue(this.staffService.getStaffById(this.staffs, currentUserID));
        this.assignmentDetailForm?.get('sales_rep_id')?.setValue(this.staffService.getStaffById(this.staffs, currentUserID));
      }

    }
  }
  initCustomerSubscription(): void {
    this.customerSubscription = this.bidDetailForm.get('bidDetail').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        const customer = next?.customer?.customer_id;
        const primary_sales_rep = customer?.primary_sales_rep
        if (!this.isEdit){
          const primarySalesRepID = primary_sales_rep?.id;
          if (primarySalesRepID){
            this.assignmentDetailForm?.get('sales_rep_id')?.setValue(this.staffService.getStaffById(this.staffs, primarySalesRepID));
          }
        }

      });
  }
  initSatffMembers = () => {
    this.tenantIdSubscription = this.subofficeService.tenantId$.subscribe((tenantId) => {
      if(typeof tenantId == 'number') {
        const current_user_id = this.currentUser.getID();
        
        // Create requests for staff types
        const projectManagerRequest = this.sharedService.getStaffs({ 
          tenant_id: tenantId,
          module_id: 16,
          check_base_permissions: 1,
          base_roles_filter: [this.CONST_PROJECT_MANAGER],
          must_include_ids: this.isEdit ? [this.model?.project_manager?.id] : []
        });

        const estimatorRequest = this.sharedService.getStaffs({ 
          tenant_id: tenantId,
          module_id: 16,
          check_base_permissions: 1,
          base_roles_filter: [this.CONST_ESTIMATOR],
          must_include_ids: this.isEdit ? [this.model?.estimator?.id] : []
        });

        const salesRepRequest = this.sharedService.getStaffs({ 
          tenant_id: tenantId,
          module_id: 16,
          check_base_permissions: 1,
          base_roles_filter: [this.CONST_SALES_REP],
          must_include_ids: this.isEdit ? [this.model?.sales_rep?.id] : []
        });

        // Use forkJoin to wait for all requests to complete
        forkJoin({
          projectManagers: projectManagerRequest,
          estimators: estimatorRequest,
          salesReps: salesRepRequest
        }).pipe(first()).subscribe((results: any) => {
          let currentStaffList: any = [];
          if(this.isEdit) {
            currentStaffList = [
              this.model?.assignee?.id, 
              this.model?.estimator?.id, 
              this.model?.sales_rep?.id, 
              this.model?.secondarySalesRep?.id
            ];
          }

          // Process each staff type
          this.project_managers = this.staffService.processStaff(results.projectManagers.data, currentStaffList);
          this.estimators = this.staffService.processStaff(results.estimators.data, currentStaffList);
          this.sales_reps = this.staffService.processStaff(results.salesReps.data, currentStaffList);
          
          // Combine project managers and sales reps for staffs array
          const combinedStaffData = [
            ...this.project_managers,
            ...this.estimators,
            ...this.sales_reps
          ];
          
          // Remove duplicates based on id
          const uniqueStaffs = Array.from(new Map(combinedStaffData.map(item => [item.id, item])).values());
          this.staffs = this.staffService.processStaff(uniqueStaffs, currentStaffList);

          // After all staff data is processed, call setDataOnEdit
          this.setDataOnEdit();
        });
      }
    });
  }
  getStaffs = (queryParam: any, type: string) => {
    if(type == this.CONST_PROJECT_MANAGER) {
      queryParam.must_include_ids = [this.model?.project_manager?.id];
    }else if(type == this.CONST_ESTIMATOR) {
      queryParam.must_include_ids = [this.model?.estimator?.id];
    }else if(type == this.CONST_SALES_REP) {
      queryParam.must_include_ids = [this.model?.sales_rep?.id];
    }
    this.sharedService.getStaffs(queryParam)
      .pipe(first())
      .subscribe(
        (data:any) => {
          let currentStaffList: any = [];
          if(this.isEdit) {
             currentStaffList = [this.model?.assignee?.id, this.model?.estimator?.id, this.model?.sales_rep?.id, this.model?.secondarySalesRep?.id];
          }
          if(type == this.CONST_PROJECT_MANAGER) {
            this.project_managers = this.staffService.processStaff(data.data,currentStaffList);
          }else if(type == this.CONST_ESTIMATOR) {
            this.estimators = this.staffService.processStaff(data.data,currentStaffList);
          }else if(type == this.CONST_SALES_REP) {
            this.sales_reps = this.staffService.processStaff(data.data,currentStaffList);
          }
          // else if(type == this.CONST_ALL_STAFF) {
          //   this.staffs = this.staffService.processStaff(data.data,currentStaffList);
          //   this.setDataOnEdit();
          // }
          // this.staffs =  this.staffService.processStaff(data.data,currentStaffList);
          
          // this.staffs = data.data.map((staff:any)=>{
          //   return {id: staff.id, name: `${staff.first_name} ${staff.last_name}`};
          // });
        });
  }


  public onTouched: () => void = () => {};

  writeValue(val: any): void {
    val && this.assignmentDetailForm.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.assignmentDetailForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.assignmentDetailForm.disable() : this.assignmentDetailForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null{
    return this.assignmentDetailForm.valid ? null : { invalidForm: {valid: false, message: "Assignment Detail Form are invalid"}};
  }

  initSubscriptions(){
    if (this.form){
      this.assignmentDetailFormSubscription = this.form.valueChanges
        .pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (this.form.touched){
            this.touchFormControls();
          }
        });
    }

  }
  touchFormControls(){
    Object.keys(this.assignmentDetailForm.controls).forEach(key => {
      this.assignmentDetailForm.get(key)?.markAsTouched();
    });
  }
  ngOnDestroy(){
    // prevent memory leak when component destroyed
    this.assignmentDetailFormSubscription?.unsubscribe();
    this.tenantIdSubscription?.unsubscribe();
    this.customerSubscription?.unsubscribe();
  }

}
